import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Rocket } from "lucide-react";
import { superApi, PLANS } from "@/lib/superApi";

export default function SuperBootstrap() {
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);
  const [planId, setPlanId] = useState("pro");
  const [form, setForm] = useState({
    branch_name: "",
    slug: "",
    username: "",
    email: "",
    password: "",
    password2: "",
    name: "",
  });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.password2) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    setLoading(true);
    try {
      const body = {
        branch_name: form.branch_name.trim(),
        username: form.username.trim(),
        email: form.email.trim(),
        password: form.password,
        name: form.name.trim(),
        plan_id: planId,
      };
      if (form.slug.trim()) body.slug = form.slug.trim();
      await superApi.post("/super/bootstrap", body);
      toast.success("Cliente configurado correctamente");
      nav("/super/cliente");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error al configurar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-8">
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-[#E63946]">Arranque inicial</div>
        <h1 className="font-display text-4xl text-white mt-1">Configurar cliente</h1>
        <p className="text-white/60 text-sm mt-2 max-w-xl">
          Crea la sucursal matriz, el administrador maestro y el plan comercial. Solo se hace una vez por instalación.
        </p>
      </div>

      <form onSubmit={submit} className="space-y-6">
        <div className="glass p-5 rounded-sm space-y-4">
          <h2 className="font-display text-xl text-white">Plan comercial</h2>
          <div className="grid gap-3">
            {PLANS.map((p) => (
              <label
                key={p.id}
                className={`flex items-start gap-3 p-4 rounded-sm border cursor-pointer transition-colors ${
                  planId === p.id ? "border-[#FFD700]/60 bg-[#FFD700]/5" : "border-white/10 hover:border-white/20"
                }`}
              >
                <input
                  type="radio"
                  name="plan"
                  checked={planId === p.id}
                  onChange={() => setPlanId(p.id)}
                  className="mt-1"
                />
                <div className="flex-1 min-w-0">
                  <div className="font-display text-lg text-white">{p.name}</div>
                  <div className="text-xs text-[#FFD700]/80">{p.tagline}</div>
                  <div className="text-xs text-white/60 mt-2 grid sm:grid-cols-2 gap-x-4 gap-y-1">
                    <span>Sucursales: {p.branches}</span>
                    <span>Admins locales: {p.branchAdmins}</span>
                    <span>Asistencia: {p.attendance}</span>
                    <span>Pagos MP: {p.payments}</span>
                  </div>
                </div>
              </label>
            ))}
          </div>
        </div>

        <div className="glass p-5 rounded-sm space-y-4">
          <h2 className="font-display text-xl text-white">Sucursal matriz</h2>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="text-xs uppercase tracking-widest text-white/60">Nombre</label>
              <input className="input-dark mt-1" required value={form.branch_name} onChange={(e) => setForm({ ...form, branch_name: e.target.value })} />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-white/60">Slug (opcional)</label>
              <input className="input-dark mt-1" value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value })} />
            </div>
          </div>
        </div>

        <div className="glass p-5 rounded-sm space-y-4">
          <h2 className="font-display text-xl text-white">Administrador maestro</h2>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="text-xs uppercase tracking-widest text-white/60">Usuario</label>
              <input className="input-dark mt-1" required value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-white/60">Correo</label>
              <input type="email" className="input-dark mt-1" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-white/60">Nombre</label>
              <input className="input-dark mt-1" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            </div>
            <div />
            <div>
              <label className="text-xs uppercase tracking-widest text-white/60">Contraseña</label>
              <input type="password" className="input-dark mt-1" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-white/60">Confirmar contraseña</label>
              <input type="password" className="input-dark mt-1" required value={form.password2} onChange={(e) => setForm({ ...form, password2: e.target.value })} />
            </div>
          </div>
        </div>

        <button type="submit" disabled={loading} className="btn-primary flex items-center gap-2">
          {loading ? <Loader2 className="animate-spin" size={16} /> : <Rocket size={16} />}
          Iniciar plataforma
        </button>
      </form>
    </div>
  );
}
